import React, { useEffect, useState } from "react";
import { About, Skills, Software, NaxtPage } from "../components/Components";
import { Footer } from "../components/Components";
import useLocoScroll from "../hooks/useLocoScroll";

const AboutPage = () => {
  const [preloader, setPreloader] = useState(true);
  const preload = () => {
    setPreloader(false);
  };
  const scrollRef = useLocoScroll(!preloader);

  useEffect(() => {
    const timer = setTimeout(() => {
      preload();
    }, 500);
    return () => clearTimeout(timer);
  }, []);
  return (
    <>
      <div ref={scrollRef}>
        <About />
        <Skills />
        <Software />
        <NaxtPage text="contact" link="/contact" />
        <Footer />
      </div>
    </>
  );
};

export default AboutPage;
